import Header from "./components/Header";
import Ticker from "./components/Ticker";
import Hero from "./components/Hero";
import AnnualRanking from "./components/AnnualRanking";
import MonthlyRanking from "./components/MonthlyRanking";
import CategoryGrid from "./components/CategoryGrid";
import HotPicks from "./components/HotPicks";
import DeepFeatures from "./components/DeepFeatures";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <Ticker />
      <main>
        <Hero />
        <AnnualRanking />
        <MonthlyRanking />
        <CategoryGrid />
        <HotPicks />
        <DeepFeatures />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}